<template>
    <div>
        <b-card no-body class="mb-2 mt-3 pl-3 questionItem">
            <b-card-body class="question-body">
                <div class="row QuestionDetail">
                    <div v-if="position" class="col-md-7 pt-2 pb-2">
                        <span v-if="language || languageSlug">
                            <span class="questionLabel" v-for="translation in question.qtranslations" >
                                <span v-if="languageSlug === translation.language.slug || language === translation.language.id">
                                    <strong style="color:#04a9c4">{{ position }}./</strong> {{ translation.label}}
                                </span>
                            </span><br/>
                        </span>
                        <span v-else>
                            <span class="questionLabel" v-for="translation in question.qtranslations" >
                                <span v-if="translation.language.slug == user.userprofile.language.slug">
                                    <strong style="color:#04a9c4">{{ position }}./</strong> {{ translation.label}}
                                </span>
                            </span><br/>
                        </span>
                        <div  class="questionAnswers" v-if="question.type !== 'TFREE'">
                            <a class="dispanswers" v-on:click="showAnswers(question.id)">{{ $t('answer_modalities')}}&nbsp;<i class="ion ion-md-arrow-dropdown"></i></a>
                            <span class="questionType" v-if="question.type === 'TFREE'">( {{ $t('free_answer')}} )</span>
                            <span class="questionType" v-if="question.type === 'TSING'">( {{ $t('simple_choice')}} )</span>
                            <span class="questionType" v-if="question.type === 'TMULT'">( {{ $('multiple_choice')}} )</span>
                            <div v-if="questionOpen === question.id" class="">
                                <span v-for="translation in question.qtranslations">
                                    <span v-if="language || languageSlug">
                                        <ul v-if="languageSlug === translation.language.slug || translation.language.id === language">
                                            <li v-for="answer in translation.answers">
                                                {{ answer.label }}
                                            </li>
                                        </ul>
                                    </span>
                                    <span v-else>
                                        <ul v-if="translation.language.slug == user.userprofile.language.slug">
                                            <li v-for="answer in translation.answers">
                                                {{ answer.label }}
                                            </li>
                                        </ul>
                                    </span>
                                    
                                </span>

                            </div>
                        </div>
                    </div>
                    <div v-if="!position" class="col-md-8 pt-2 pb-2">
                        <span class="custombadge" v-for="tag in question.tags" :style="'background-color:' + tag.color">
                            <template v-if="$cookie.get('language') == 'fr'">{{tag.label}}</template>
                            <template v-else>{{tag.label_en}}</template>
                            
                        </span><br/>
                        <span v-if="language || languageSlug">
                            <span class="questionLabel" v-for="translation in question.qtranslations" >
                                <span v-if="languageSlug === translation.language.slug || language === translation.language.id">
                                    <strong style="color:#04a9c4">{{ position }}./</strong> {{ translation.label}}
                                </span>
                            </span><br/>
                        </span>
                        <span v-else>
                            <span class="questionLabel" v-for="translation in question.qtranslations" >
                                <span v-if="translation.language.slug == user.userprofile.language.slug">
                                    <strong style="color:#04a9c4">{{ position }}./</strong> {{ translation.label}}
                                </span>
                            </span><br/>
                        </span>
                        <div  class="questionAnswers" v-if="question.type !== 'TFREE'">
                            <a class="dispanswers" v-on:click="showAnswers(question.id)">{{ $t('answer_modalities')&nbsp;}}<i class="ion ion-md-arrow-dropdown"></i></a>
                            <div v-if="questionOpen === question.id" class="">
                                <span v-for="translation in question.qtranslations">
                                    <span v-if="language || languageSlug">
                                        <ul v-if="languageSlug === translation.language.slug || translation.language.id === language">
                                            <li v-for="answer in translation.answers">
                                                {{ answer.label }}
                                            </li>
                                        </ul>
                                    </span>
                                    <span v-else>
                                        <ul v-if="translation.language.slug == user.userprofile.language.slug">
                                            <li v-for="answer in translation.answers">
                                                {{ answer.label }}
                                            </li>
                                        </ul>
                                    </span>
                                </span>
                            </div>
                            <span class="questionType" v-if="question.type === 'TFREE'">( {{ $t('free_answer')}} )</span>
                            <span class="questionType" v-if="question.type === 'TSING'">( {{ $t('simple_choice')}} )</span>
                            <span class="questionType" v-if="question.type === 'TMULT'">( {{ $t('multiple_choice')}} )</span>
                        </div>
                    </div>
                    <div class="col-md-4 questionAction pt-2 pb-2">
                        <slot></slot>
                    </div>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            question: {
                type: Object,
                required: true
            },
            source: {
                type: String,
                required: true
            },
            position: {
                type: Number,
                required: false
            },
            language: {
                type:Number,
                required: false
            },
            languageSlug: {
                type:String,
                required: false
            },
        },
        data() {
            return {
                questionOpen: 0
            }
        },
        computed: mapState({ user: state => state.user.user }),
        methods: {
            showAnswers(question_id) {
                if (this.questionOpen === question_id) {
                    this.questionOpen = 0;
                } else {
                    this.questionOpen = question_id;
                }
            },
        }
    }
</script>
<style>
    .questionItem {
        border: 2px solid rgba(126, 126, 126, 0.09) !important;
    }
    .questionAction {
        text-align:right;
    }
    .QuestionDetail ul li {
        color: #3c3c3c;
        list-style: none;
        padding: 0;
        padding-top: 6px;
        position: relative;
    }
    .QuestionDetail ul li::before {
        color: #57A9FF;
        content: "\2022";
        display: inline-block;
        font-size: 1.5rem;
        left: -1.1225em;
        position: absolute;
        top: 0em;
    }
    .QuestionDetail .btn-secondary {
        color:#92969D;
        background: none;
        padding:0px;
        margin-left:10px;
    }
    .questionAction i {
        color:#92969D;
        background: none;
        font-size:1.3rem;
    }
    .dispanswers {
        color: #57A9FF !important;
        cursor:pointer;
    }
    .custombadge {
        height:25px;
        border-radius: 4px !important;
        line-height:25px;
        padding-left:10px;
        padding-right:10px;
        color:#ffffff;
        margin-right: 10px;
        display:inline-block;
    }
    .questionLabel {
        margin-top:10px;
        margin-bottom: 10px;
        display:inline-block;
    }
    .questionType {
        margin-left:10px;
        color:#92969D;
    }
    .questionAnswers{
        display:inline-block;
        float:left;
    }
    .questionPosition{
        background-color:#00AAC2;
        color:#ffffff;
        text-align:center;
        font-size:13px;
        height:30px;
        padding: 0 !important;
    }
    .question-body {
        padding: 0 1rem 0 0;
    }
</style>
